import React from "react"
import PropTypes from "prop-types"

import checkmark from "images/icons/checkmark.svg"
import "./service_tile.scss"

const ServiceTile = ({ selected, channel, onClick }) => (
  <a
    style={{ background: `#${channel.brand_color}` }}
    onClick={onClick}
    styleName="inner-tile"
  >
    <img styleName="service-icon" src={channel.lrg_monochrome_image_url} />
    <div>{channel.name}</div>
    {selected ? (
      <div
        styleName="selection-icon"
        dangerouslySetInnerHTML={{ __html: checkmark }}
      />
    ) : (
      <div styleName="unselected selection-icon" />
    )}
  </a>
)

ServiceTile.propTypes = {
  selected: PropTypes.bool.isRequired,
  channel: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default ServiceTile
